import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { BsEye } from "react-icons/bs";
import { FaRegEdit } from "react-icons/fa";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { ERROR_MSG } from "../../CommonUtilities/Validations/RegularExpAndVar";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtilities/CommonAxios/CommonAxios";
import Sweetalert from "../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts";
import { CommonReactTable } from "../../CommonUtilities/CommonTable/CommonReactTable";
import { config } from "../../CommonUtilities/CommonUrl/CommonUrls";
import { CommonPageHeading } from "../../CommonUtilities/CommonHeading/CommonPageHeading";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { FaCircleArrowLeft } from "react-icons/fa6";
import { useSelector } from "react-redux";
import ImageBucket from "../../CommonUtilities/CommonFileUpload/ImageBucket";
import Swal from "sweetalert2";
import { viewImage } from "../../CommonUtilities/CommonFileUpload/ViewImage";

const POST_COURSE_MAPPING = {
    SSC_INTER_UG_PG_BED: [715, 717, 718, 719, 720, 722, 723, 753, 754, 755, 756, 757, 758, 759, 913],
    SSC_INTER_UG_BED: [728, 729, 746, 747, 925, 926, 927],
    SSC_INTER_BED: [945],
};
const allCourses = [
    {
        key: "SSC",
        weightKey: "ssc_weight",
        percentageKey: "ssc_percentage",
        course: "SSC",
    },
    {
        key: "INTER",
        weightKey: "inter_weight",
        percentageKey: "inter_percentage",
        course: "Intermediate",
    },
    {
        key: "UG",
        weightKey: "ug_weight",
        percentageKey: "ug_percentage",
        course: "UG",
    },
    {
        key: "PG",
        weightKey: "pg_weight",
        percentageKey: "pg_percentage",
        course: "PG",
    },
    {
        key: "BED",
        weightKey: "bed_weight",
        percentageKey: "bed_percentage",
        course: "B.E.D/Professional Qualification",
    },
];

export default function RaiseGrievance() {
    const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
    // ****************post api *******************
    const submitDetails = async (values, formik) => {
        if (values?.uploadDoc && (values.uploadDoc.includes("fakepath") || values.uploadDoc.includes("fakePath"))) {
            Swal.fire({
                text: "Document not uploaded correctly , Please upload it again",
                icon: "warning",
                backdrop: false,
                allowOutsideClick: false,
                didOpen: () => {
                    const swalModal = Swal.getPopup();
                    if (swalModal) {
                        swalModal.setAttribute("tabindex", "0");
                        swalModal.focus();
                    }
                },
            }).then((refresh) => {
                if (refresh.isConfirmed) {
                    formik.setFieldValue("uploadDoc", "");
                }
            })
        }
        else {
            Swal.fire({
                title: 'Are you sure?',
                text: "Do you want to submit?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, submit it!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let res = await CommonAxiosPost(config.url.CONTEXT_URL + "candidate-grievance", values);
                    if (res !== undefined) {
                        if (res?.data?.scode === "01") {
                            Sweetalert("Submitted Successfully", "success").then(() => {
                                initFormik.resetForm();
                                formIk.resetForm();
                                setDrillCount(0);

                                getReport();
                            });
                        } else {
                            Sweetalert(res?.data?.sdesc, "error");

                        }
                    } else {
                        Sweetalert(res?.data?.sdesc, "error");
                    }
                }
            });
        }
    };
    const initFormik = useFormik({
        initialValues: {
            prblmType: '',
            remarks: "",
            uploadDoc: "",
        },
        validationSchema: Yup.object({
            prblmType: Yup.string().required(ERROR_MSG),
            remarks: Yup.string().required(ERROR_MSG)
                .max(500, "Remarks should not exceed 500 characters").nullable(),
            uploadDoc: Yup.string().required(ERROR_MSG).nullable(),
        }),
        onSubmit: (values) => {
            // console.log("val>>>>", values)
            submitDetails(values, initFormik);
        }
    })

    const formIk = useFormik({
        enableReinitialize: false,
        initialValues: {
            weightageRows: [],
            remarks: "",
            uploadDoc: "",
        },
        validationSchema: Yup.object({
            weightageRows: Yup.array()
                .of(
                    Yup.object({
                        selected: Yup.boolean(),
                        correction: Yup.string().when("selected", {
                            is: true,
                            then: (schema) =>
                                schema
                                    .required(ERROR_MSG)
                                    .matches(
                                        /^(100(\.0{1,2})?|[1-9][0-9](\.\d{1,2})?)$/,
                                        "Enter a valid percentage"
                                    )
                                    .max(5, "Maximum length is 5 characters"),
                            otherwise: (schema) => schema.notRequired(),
                        }),
                    })
                )
                .test(
                    "at-least-one-selected",
                    "Please select at least one course.",
                    (value) => value?.some((item) => item.selected) || false
                ),
            remarks: Yup.string().required(ERROR_MSG)
                .max(500, "Remarks should not exceed 500 characters").nullable(),
            uploadDoc: Yup.string().required(ERROR_MSG).nullable(),
        }),
        onSubmit: (values) => {
            // console.log(values.weightageRows);
            const scorePayload = {
                prblmType: initFormik?.values?.prblmType,
                grievanceList: values.weightageRows
                    .filter(item => item.selected)
                    .map(item => ({
                        course: item.qualification_id,
                        // weight: item.weight,
                        percentage: item.ssc_percentage,
                        correction: item.correction,
                        qualLevel: item.qual_level
                    })),
                remarks: values.remarks,
                uploadDoc: values?.uploadDoc
            };

            //console.log("payload>>>>", scorePayload);
            submitDetails(scorePayload, formIk);
        }
    })

    // const [showPosts, setPosts] = useState([]);
    const [drillCount, setDrillCount] = useState(0);
    // const getCandidatePosts = () => {
    //     let url = config.url.CONTEXT_READ_URL + "candidate-grievance-data";
    //     CommonAxiosGet(url).then((res) => {
    //         if (res?.data?.status === true) {
    //             setPosts(res?.data?.posts);
    //         } else {
    //             setPosts([]);
    //         }
    //     });
    // };



    function getWeightage() {//postId
        let url = config.url.CONTEXT_READ_URL + "candidate-weightage-data";

        CommonAxiosGet(url).then((res) => {
            if (res?.data?.status) {
                const item = res.data.posts[0];

                // const allowedCourses = (() => {
                //      if (POST_COURSE_MAPPING.SSC_INTER_UG_PG_BED.includes(postId))
                //     return ["SSC", "INTER", "UG", "PG", "BED"];

                //     if (POST_COURSE_MAPPING.SSC_INTER_UG_BED.includes(postId))
                //         return ["SSC", "INTER", "UG", "BED"];

                //     if (POST_COURSE_MAPPING.SSC_INTER_BED.includes(postId))
                //         return ["SSC", "INTER", "BED"];

                //     return [];
                // })();

                // const rows = allCourses
                //     .filter(course => allowedCourses.includes(course.key))
                //     .map(course => ({
                //         course: course.course,
                //         weightKey: course.weightKey,
                //         percentageKey: course.percentageKey,
                //         weight: item[course.weightKey],
                //         percentage: item[course.percentageKey],
                //         selected: false,
                //         correction: "",
                //     }));

                const rows = [
                    {
                        course: "SSC",
                        weightKey: "ssc_weight",
                        percentageKey: "ssc_percentage",
                        weight: item.ssc_weight,
                        percentage: item.ssc_percentage,
                        selected: false,
                        correction: "",
                    },
                    {
                        course: "Intermediate",
                        weightKey: "inter_weight",
                        percentageKey: "inter_percentage",
                        weight: item.inter_weight,
                        percentage: item.inter_percentage,
                        selected: false,
                        correction: "",
                    },
                    {
                        course: "UG",
                        weightKey: "ug_weight",
                        percentageKey: "ug_percentage",
                        weight: item.ug_weight,
                        percentage: item.ug_percentage,
                        selected: false,
                        correction: "",
                    },
                    {
                        course: "PG",
                        weightKey: "pg_weight",
                        percentageKey: "pg_percentage",
                        weight: item.pg_weight,
                        percentage: item.pg_percentage,
                        selected: false,
                        correction: "",
                    },
                    {
                        course: "B.E.D/Professional Qualification",
                        weightKey: "bed_weight",
                        percentageKey: "bed_percentage",
                        weight: item.bed_weight,
                        percentage: item.bed_percentage,
                        selected: false,
                        correction: "",
                    },
                ];

                formIk.setFieldValue("weightageRows", rows);
                setDrillCount(1);
            }
        });
    }


    // const columns1 = [
    //     { Header: "Sl.No", accessor: (row, index) => index + 1 },
    //     {
    //         Header: "Posts",
    //         accessor: (row) => row?.post_name || "-",
    //     },
    //     {
    //         Header: "Raise Grievance",
    //         accessor: (row) => (
    //             <div className="text-center">
    //                 <Button
    //                     type="button"
    //                     className="btn btn-primary p-2 pt-1"
    //                     onClick={() => {
    //                         getWeightage(row?.post_id);
    //                     }}
    //                 >
    //                     <ArrowCircleRightIcon />
    //                 </Button>
    //             </div>
    //         ),
    //     }
    // ]
    const weightageColumns = React.useMemo(() => [
        {
            Header: "Sl.No",
            id: "select",
            Cell: ({ row }) => (
                <div className="d-flex align-items-center gap-2">
                    <input id="check"
                        type="checkbox"
                        className="form-check-input"
                        checked={formIk.values.weightageRows?.[row.index]?.selected || false}
                        onChange={(e) => {
                            const checked = e.target.checked;

                            formIk.setFieldValue(
                                `weightageRows[${row.index}].selected`,
                                checked, true
                            );

                            if (!checked) {
                                formIk.setFieldValue(
                                    `weightageRows[${row.index}].correction`,
                                    ""
                                );
                            }
                        }}
                    />
                    <span>{row.index + 1}</span>
                </div>
            ),
        },
        {
            Header: "Course",
            accessor: "qual_level",
        },
        // {
        //     Header: "Weightage",
        //     accessor: "weight",
        // },
        {
            Header: "Percentage",
            accessor: "ssc_percentage",
        },
        {
            Header: "Correction Of Percentage",
            accessor: (row, index) => (
                <>
                    <Field
                        type="text"
                        name={`weightageRows[${index}].correction`}
                        className="form-control"
                        maxLength={5}
                        disabled={!formIk.values.weightageRows?.[index]?.selected}
                        onKeyDown={(e) => {
                            const allowedKeys = [
                                "Backspace",
                                "Delete",
                                "Tab",
                                "ArrowLeft",
                                "ArrowRight",
                                "Home",
                                "End",
                            ];

                            if (allowedKeys.includes(e.key)) return;

                            if (!/[0-9.]/.test(e.key)) {
                                e.preventDefault();
                            }

                            if (e.key === "." && e.target.value.includes(".")) {
                                e.preventDefault();
                            }
                        }}
                        onInput={(e) => {
                            e.target.value = e.target.value
                                .replace(/[^0-9.]/g, "")
                                .replace(/(\..*)\./g, "$1");
                        }}
                    />

                    <ErrorMessage name={`weightageRows[${index}].correction`} component="div" className="text-error" />
                </>
            ),
        }
    ], [formIk.values.weightageRows]);
    // ************get submited data report ****************
    const [showReport, setReport] = useState([]);
    const [showCoursesData, setCoursesData] = useState([]);
    function getReport() {
        const url = config.url.CONTEXT_READ_URL + "candidate-grievance-data";

        CommonAxiosGet(url).then((res) => {
            const response = res?.data || {};
            const reportData = Array.isArray(response.data)
                ? response.data.map((grievance) => ({
                    ...grievance,
                    courseList: (response.course || []).filter(
                        (course) =>
                            course.correction !== null &&
                            course.correction !== ""
                    ),
                }))
                : [];

            setReport(reportData);

            const rows = Array.isArray(response.course)
                ? response.course.map((item) => ({
                    ...item,
                    selected: false,
                    correction: "",
                }))
                : [];

            setCoursesData(rows);
            formIk.setFieldValue("weightageRows", rows);
        })
            .catch(() => {
                setReport([]);
                setCoursesData([]);
            });
    }
    useEffect(() => { getReport(); }, [])
    const isScoreRaised = showReport?.some(
        (item) => item?.prblm_type?.trim()?.toUpperCase() === "SCORE"
    ) || false;

    const columns3 = [
        { Header: "Sl.No", accessor: (row, index) => index + 1 },
        {
            Header: "Problem Type",
            accessor: (row) => row?.prblm_type || "-",
        },
        {
            Header: "Corrected Data",
            accessor: (row) => {
                if (row.prblm_type !== "Score") return "-";

                if (!row.courseList?.length) return "-";

                return row.courseList.map((item, index) => (
                    <React.Fragment key={index}>
                        {item.qual_level} - Actual %: {item.ssc_percentage} - Corrected %: {item.correction}
                        {index < row.courseList.length - 1 && <br />}
                    </React.Fragment>
                ));
            },
        },
        // {
        //     Header: "Corrected Data",
        //     accessor: (row) => {
        //         if (!row?.course_actual_correction) return "-";
        //         if (!row?.course_actual_correction) return "-";

        //         const data = row.course_actual_correction.split(",");

        //         return data.map((item, index) => (
        //             <React.Fragment key={index}>
        //                 {item.trim()}
        //                 {index < data.length - 1 && <br />}
        //             </React.Fragment>
        //         ));
        //     },
        // },
        {
            Header: "Remarks",
            accessor: (row) => row?.remarks || "-",
        },
        {
            id: "uploadedDocument",
            Header: <>Uploaded <br />Document</>,
            // Header: "Uploaded Document",
            accessor: (row) =>
                row?.upload ? (
                    <Button
                        type="button"
                        className="btn btn-primary btn-sm no-print"
                        onClick={() => viewImage(row.upload)}
                    >
                        <BsEye />
                    </Button>
                ) : (
                    "-"
                ),
        },
        {
            Header: "Status",
            accessor: (row) => {
                if (row.prblm_type !== "Score") {
                    return row?.status || "-";
                }

                if (!row.courseList?.length) return "-";

                return (
                    <div
                        style={{ width: "250px", maxWidth: "250px", whiteSpace: "normal", wordBreak: "break-word", }}
                    >
                        {row.courseList.map((item, index) => (
                            <React.Fragment key={item.qualification_id}>
                                <b>{item.qual_level}</b> - {item.status || "Pending"}

                                {item.status === "Rejected" && item.remarks && (
                                    <>
                                        <br />
                                        <span className="text-danger">
                                            <b>Remarks:</b> {item.remarks}
                                        </span>
                                    </>
                                )}

                                {index < row.courseList.length - 1 && (
                                    <>
                                        <br />
                                        <br />
                                    </>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                );
            },
        }
        // {
        //     Header: "Status",
        //     accessor: (row) => row?.status || "-",
        // },
    ]


    return (
        <React.Fragment>
            <CommonPageHeading heading="Raise Grievance" />
            {!isScoreRaised && (<React.Fragment>
                <FormikProvider value={initFormik}>
                    <Form className="form-section" onSubmit={initFormik.handleSubmit} onChange={initFormik.handleChange} >
                        <Row>
                            <Col xxl={4} xl={4} lg={4} md={6} sm={12} xs={12} className="mb-3" >
                                <Form.Group controlId="prblmType">
                                    <Form.Label className="input-lable mb-2">
                                        Type of Problem <font color="red">*</font>
                                    </Form.Label>
                                    <Field as="select" name="prblmType"
                                        className="input-field form-select rounded"
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            initFormik.setFieldValue("prblmType", value);
                                            initFormik.setFieldValue("remarks", "");
                                            initFormik.setFieldValue("uploadDoc", "");

                                            // Reset Score grievance form
                                            // if (value === "Other") {
                                            //     formIk.resetForm();
                                            //     setDrillCount(0);
                                            // }
                                            if (value === "Score") {
                                                setDrillCount(1);
                                                formIk.setValues({
                                                    weightageRows: showCoursesData,
                                                    remarks: "",
                                                    uploadDoc: "",
                                                });
                                                //getWeightage();
                                            }
                                        }}
                                    >
                                        <option value="">--Select--</option>
                                        {/* {!isScoreRaised && ( */}
                                        <option value="Score">Score</option>
                                        {/* )} */}
                                        {/* <option value="Other">Other</option> */}
                                    </Field>
                                    <ErrorMessage name="prblmType" component="div" className="text-error" />
                                </Form.Group>
                            </Col>
                        </Row>
                        {/* {initFormik?.values?.prblmType === 'Other' && (<React.Fragment>
                        <Row className="mt-3">
                            <Col md={4}>
                                <label className="form-label">
                                    Enter Description <span className="text-danger">*</span>
                                </label>

                                <Field as="textarea" rows={2} name="remarks"
                                    className="form-control"
                                    maxLength={500}
                                    placeholder="Enter Description"
                                />

                                <ErrorMessage name="remarks" component="div" className="text-error" />
                            </Col>
                            <Col md={4}>
                                <label className="form-label">
                                    Upload Document <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="file"
                                    className="form-control"
                                    accept=".jpg,.jpeg,.png,.pdf"
                                    name='uploadDoc'
                                    onChange={(e) => {
                                        let filename = loginreducer?.candidate_id + "_grievanceDoc";
                                        ImageBucket(e, initFormik, 'uploadDoc', filename, 'DSC_UPLOADS');
                                    }} />

                                <ErrorMessage name="uploadDoc" component="div" className="text-danger small" />
                            </Col>
                            <Col md={4} className="pt-4">
                                <button type='submit' className='btn btn-success'
                                >Submit</button>
                            </Col>
                        </Row>

                    </React.Fragment>)} */}
                    </Form>
                </FormikProvider>

                <FormikProvider value={formIk}>
                    <Form className="form-section" onSubmit={formIk.handleSubmit} onChange={formIk.handleChange} >
                        {(initFormik?.values?.prblmType === 'Score' && !isScoreRaised) && (<React.Fragment>
                            {/* {(drillCount === 0 && showPosts?.length > 0) &&
                            <div className="table-responsive mt-3">
                                <CommonReactTable
                                    tableid="addigned-cand"
                                    pagination="false"
                                    data={showPosts}
                                    columns={columns1}
                                    serachAlign="left"
                                    isBack={false}
                                    headerName={<>Raise Grievance Report</>}
                                    headColumCount={8}
                                    paginationCount="All"
                                    search="true"
                                    showFooter="false"
                                    filename="Raise Grievance Report"
                                />
                            </div>
                        } */}

                            {(drillCount === 1 && formIk?.values?.weightageRows?.length > 0) &&
                                <div className="table-responsive mt-3">
                                    {/* <div className="d-flex align-items-center justify-content-end">
                                    <button type='button' className='btn btn-secondary'
                                        onClick={() => { setDrillCount(0); formIk.resetForm(); }}><FaCircleArrowLeft size={20} /> &nbsp;Back To Posts</button>
                                </div> */}

                                    <div style={{ background: "#dcf1f5" }}>
                                        <strong className="text-danger px-1">Note:</strong>
                                        <ul>
                                            <li>
                                                Grievance can be submitted only once. Please verify all the details carefully before submitting.
                                            </li>
                                            <li>
                                                If you need to request corrections for multiple courses, select all the applicable courses and submit them together in a single grievance.
                                            </li>
                                            <li>
                                                Upload a single supporting document containing proof for all the requested corrections.
                                            </li>
                                            <li>
                                                In the <b>Correction of Percentage</b> field, enter only the corrected percentage as per your supporting document.
                                            </li>
                                        </ul>
                                    </div>
                                    {typeof formIk.errors.weightageRows === "string" &&
                                        formIk.submitCount > 0 && (
                                            <div className="text-danger">
                                                {formIk.errors.weightageRows}
                                            </div>
                                        )}
                                    <CommonReactTable
                                        tableid="percentage-table"
                                        pagination="false"
                                        data={formIk.values.weightageRows}
                                        // data={showCoursesData}
                                        columns={weightageColumns}
                                        serachAlign="left"
                                        isBack={false}
                                        headerName={<>Percentage Details</>}
                                        headColumCount={5}
                                        paginationCount="All"
                                        search="false"
                                        showFooter="false"
                                        filename="Percentage Details"
                                    />
                                    <Row className="mt-3">
                                        <Col md={6}>
                                            <label className="form-label">
                                                Remarks <span className="text-danger">*</span>
                                            </label>

                                            <Field as="textarea" rows={1} name="remarks"
                                                className="form-control"
                                                maxLength={500}
                                                placeholder="Enter remarks"
                                            />

                                            <ErrorMessage name="remarks" component="div" className="text-danger small" />
                                        </Col>

                                        <Col md={6}>
                                            <label className="form-label">
                                                Upload Document <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                accept=".jpg,.jpeg,.png,.pdf"
                                                name='uploadDoc'
                                                onChange={(e) => {
                                                    let filename = loginreducer?.candidate_id + "_grievanceDoc";
                                                    ImageBucket(e, formIk, 'uploadDoc', filename, 'DSC_UPLOADS');
                                                }} />

                                            <ErrorMessage name="uploadDoc" component="div" className="text-danger small" />
                                        </Col>
                                    </Row>
                                    <div className="d-flex align-items-center justify-content-end pt-2">
                                        <button type='submit' className='btn btn-success'
                                        >Submit</button>
                                    </div>
                                </div>
                            }
                        </React.Fragment>)}
                    </Form>
                </FormikProvider>
            </React.Fragment>)}
            {/* && initFormik?.values?.prblmType === "" */}
            {(drillCount === 0 && showReport?.length > 0) &&
                <div className="table-responsive mt-3">
                    <CommonReactTable
                        tableid="addigned-cand"
                        pagination="false"
                        data={showReport}
                        columns={columns3}
                        serachAlign="left"
                        isBack={false}
                        headerName={<>Raised Grievance Report</>}
                        headColumCount={8}
                        paginationCount="All"
                        search="true"
                        showFooter="false"
                        filename="Raised Grievance Report"
                    />
                </div>
            }
        </React.Fragment>
    )
}
